import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IResidualLandValueApiResponse } from '../types';
import { prepareBackOfEnvelopePayload } from '../../SlideoutForm/helpers';
import { BOESlideoutFormValues } from '../../SlideoutForm/types';

interface ResidualLandValueInput {
    boeValues: BOESlideoutFormValues;
    targetReturnOnCost: number | null;
    targetReturnOnEquity: number | null;
    targetProfitReturn: number | null;
}

export const useCalculateResidualLandValue = () => useMutation({
    mutationFn: async (input: ResidualLandValueInput): Promise<IResidualLandValueApiResponse> => {
        const basePayload = prepareBackOfEnvelopePayload(input.boeValues);

        const payload = {
            ...basePayload,
            targetReturnOnCost: input.targetReturnOnCost !== null ? input.targetReturnOnCost / 100 : null,
            targetReturnOnEquity: input.targetReturnOnEquity !== null ? input.targetReturnOnEquity / 100 : null,
            targetProfitReturn: input.targetProfitReturn,
        };

        const response = await axiosInstance.post<IResidualLandValueApiResponse>(
            API_ENDPOINTS.BACK_OF_ENVELOPE_CALCULATE_RESIDUAL,
            payload,
        );
        return response.data;
    },
});
